const mix = (arr) => arr
    .filter(Boolean)
    .join(' ')

export default mix